/**
 * V69 (2026-06-02): KR 격주 재택 금요일 계산 공용 helper.
 *
 * 정책:
 *   - 대상 국가: KR only (호출처에서 companyCode === 'KR' 가드)
 *   - 기준일: 2026-06-05 (금)
 *   - 14일 간격 반복 → 06-05 / 06-19 / 07-03 / 07-17 / ...
 *   - DB 저장 / Firestore patch / 스케줄러 0 — 표시 전용 계산식
 *   - 휴가/근태/지각/자동퇴근 무관
 *
 * 표시 스타일 가이드 (FE 페이지에서 공통 적용):
 *   - 셀 배경: `#FFFBEB` (very light yellow)
 *   - 배지 배경: `#FEF3C7`, border `1px solid #FDE68A`
 *   - 배지 텍스트: `#D97706` (muted amber), fontSize 9px, fontWeight 600
 *   - pill (`borderRadius: 999px`), `padding: 0px 6px`, `pointerEvents: 'none'`
 *   - 휴일이면 휴일 우선 (배지/노랑 배경 미적용)
 *
 * 사용처:
 *   - 조직 휴가 캘린더 (`OrgLeaveCalendarPage`)
 *   - 근로일정 캘린더 (`WorkSchedulePage`)
 */

export const KR_REMOTE_FRIDAY_BASE_DATE = new Date(2026, 5, 5); // 2026-06-05 금 (month=5 0-based)
const KR_REMOTE_FRIDAY_BASE_MS = KR_REMOTE_FRIDAY_BASE_DATE.getTime();
const MS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * 주어진 날짜가 KR 격주 재택 금요일인지 판정.
 *
 * @param date Date 객체 — 로컬 타임존 기준
 * @returns 금요일이고 baseDate(2026-06-05) 와의 차이가 14일 배수(>=0) 이면 true
 */
export function isKrRemoteFriday(date: Date): boolean {
  if (date.getDay() !== 5) return false; // 금요일 (0=일, 5=금)
  // round 으로 부동소수점 / 타임존 경계 오차 회피
  const dayDiff = Math.round((date.getTime() - KR_REMOTE_FRIDAY_BASE_MS) / MS_PER_DAY);
  return dayDiff >= 0 && dayDiff % 14 === 0;
}

/**
 * 'YYYY-MM-DD' 문자열 → Date 변환 후 isKrRemoteFriday 적용 (편의 함수).
 */
export function isKrRemoteFridayYmd(ymd: string): boolean {
  if (!ymd || ymd.length < 10) return false;
  const y = parseInt(ymd.substring(0, 4), 10);
  const m = parseInt(ymd.substring(5, 7), 10);
  const d = parseInt(ymd.substring(8, 10), 10);
  if (!y || !m || !d) return false;
  return isKrRemoteFriday(new Date(y, m - 1, d));
}
